/* eslint-disable @typescript-eslint/naming-convention */
import { TransferBaseRequestDto } from './transfer-base-request.dto';

export class ExternalTransferRequestDto extends TransferBaseRequestDto {
	public ExternalTransferId: string;

	public constructor(parameters: Partial<ExternalTransferRequestDto>) {
		super({
			AuthenticationMethod: parameters.AuthenticationMethod,
			Environment: parameters.Environment
		});
		this.ExternalTransferId = parameters.ExternalTransferId;
	}
}
